import ApplicationForm from '@/components/forms/ApplicationForm';

export default function SpacesThemeCamps() {
  return (
    <ApplicationForm
      applicationType="spaces-theme-camps"
      title="Spaces & Theme Camps"
      description="Bring your creative vision to life! We're looking for theme camps, chill spaces, 
        interactive installations, and unique gathering spots that enhance the Frequency Forest experience."
      showPortfolio={true}
      showExperience={true}
      showRequirements={true}
      showInsurance={true}
      showCertificates={false}
    />
  );
}
